import React from "react";
import { IconButton } from "@mui/material";
import IconFav from "src/assets/images/heart-favorite.png";
import { getInitialsImage } from "src/helpers/helperFunctions";
import RenderText from "src/Components/Text/RenderText";
import AddCartButton from "src/Components/GlobalComponents/AddCartButton";
import TimeIcon from "src/assets/images/website-images/history-icon.png";
import FavoriteCoponent from "src/Components/GlobalComponents/FavoriteCoponent";
import PriceView from "src/Components/GlobalComponents/PriceView";

interface IObj {
  _id: string;
  serviceName: string;
  image: string;
  ratingCount: number;
  averageRating: number;
  price: number;
  prescriptionRequired: boolean;
  isLiked: boolean;
  shortDescription: string;
  serviceDuration: number;
  healthCareProvider: string;
}

interface TestWhishListCardProps {
  data: IObj;
  heart_id?: string;
  button_id?: string;
  handleRemove: () => void;
  onAppointmentClick?: (id?: string) => void;
}

const BoxIcon = ({ icon, title }: { icon: string; title: string }) => {
  return (
    <div className="flex gap-1 items-center">
      <div className="w-[15px] h-[15px]  border border-gray-400 rounded flex items-center justify-center">
        <img
          src={icon}
          alt="icon"
          className="max-w-[80%] max-h-[80%] object-contain"
        />
      </div>
      <RenderText className="font-Poppins-Regular font-size-12px text-[#333333]">
        {title}
      </RenderText>
    </div>
  );
};

const AtHomeServiceWishListCard = ({
  data,
  heart_id,
  button_id,
  handleRemove,
  onAppointmentClick,
}: TestWhishListCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-all-light-2 px-[6px] 2xl:px-2 py-2 2xl:py-3 flex gap-1 2xl:gap-2 items-center">
      <FavoriteCoponent
        category="homecare"
        onLikeProduct={handleRemove}
        id={data?._id}
        liked={data?.isLiked}
        className="bg-transparent"
        isWhishList
      />
      <div className="flex flex-col gap-2 flex-1">
        <div className="flex gap-2 2xl:gap-3 w-full">
          <div className="max-w-[5vw] rounded-lg h-fit overflow-hidden">
            <img
              src={`${data.image || ""}`}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = getInitialsImage(
                  data.serviceName,
                  112,
                  48,
                  "#00443f"
                );
              }}
              alt={data.serviceName}
              className="aspect-square object-cover"
            />
          </div>
          <div className="w-[calc(100%-5vw-10px)] flex flex-col gap-1">
            <RenderText className="font-Montserrat-SemiBold font-size-20px wishlist-homeservice-main-text-color">
              {data.serviceName}
            </RenderText>
            <div className="flex gap-1 items-center">
              <img src={TimeIcon} alt="Time" className="w-[15px] h-[15px]" />
              <p className="font-Poppins-Regular font-size-16px text-[#707070]">
                {data.serviceDuration} Hour{data.serviceDuration > 1 ? "s" : ""}
              </p>
            </div>
          </div>
        </div>
        <div className="flex w-full gap-2 justify-between">
          <PriceView
            salePrice={null}
            regularPrice={data?.price || 0}
            className="!font-Poppins-SemiBold"
            regularClassName="text-[#434343] font-size-15px-important"
            saleClassName="!text-[#202020] font-size-20px-important"
          />
          <AddCartButton productId={data?._id} icon="Calender" onClick={(e , id) => {
            onAppointmentClick?.(id);
          }} id={button_id} type="homecare" />
        </div>
      </div>
    </div>
  );
};

export default AtHomeServiceWishListCard;
